import { all, fork, put, takeEvery } from "redux-saga/effects";

import {

    // Customer Management
    SETTING_LOAD_ORGANIZATION_TYPE,
    SETTING_CREATE_ORGANIZATION_TYPE,
    SETTING_UPDATE_ORGANIZATION_TYPE,
    SETTING_DELETE_ORGANIZATION_TYPE,

    SETTING_LOAD_ORGANIZATION,
    SETTING_CREATE_ORGANIZATION,
    SETTING_UPDATE_ORGANIZATION,
    SETTING_DELETE_ORGANIZATION,


    SETTING_LOAD_CUSTOMER,
    SETTING_CREATE_CUSTOMER,
    SETTING_UPDATE_CUSTOMER,
    SETTING_DELETE_CUSTOMER,

    // SETTING_UPDATE_CUSTOMER_STATUS,

    // END Customer Management

} from "../../actions";

import {
    // Customer Management
    settingGetOrganizationType,
    settingAddOrganizationType,
    settingUpdateOrganizationType,
    settingDeleteOrganizationType,

    settingGetOrganization,
    settingAddOrganization,
    settingUpdateOrganization,
    settingDeleteOrganization,

    settingGetCustomer,
    settingAddCustomer,
    settingUpdateCustomer,
    settingDeleteCustomer,
    // settingUpdateChangeStatusCustomer,

    // END Customer Management

} from "../../../helpers/setting-api";

import {
    addressGetNameTitle,
} from "../../../helpers/address-api";

import {
    getOrganizationType,
    getOrganizationTypeSuccess,
    getOrganization,
    getOrganizationSuccess,
    getCustomer,
    getCustomerSuccess,
} from "./actions";

import { NotificationManager } from '../../../components/common/react-notifications';

const PullNotificationManager = async (text) => {
    // eslint-disable-next-line no-return-await
    await NotificationManager.warning(text, 'Error', 3000, null, null, '');
}

// Customer Management
function* settingManagementLoadOrganizationType({ payload, token }) {
    try {
        const dataRes = yield settingGetOrganizationType(payload, token);
        if (dataRes.status === 'success') {
            // let list = [];
            // const dataFilter = dataRes.data.filter(el => el.name_department === "Owner")
            // const allDataFilter = dataRes.data.filter(el => el.name_department !== "Owner")
            // const checkDataFilter = [...dataFilter || (null), ...allDataFilter || dataRes.data]
            const list = dataRes.data.map(item => (
                {
                    ...item,
                    label: item.name_organization_type,
                    value: item.id_organization_type,
                }
            ));
            yield put(getOrganizationTypeSuccess(dataRes.data, list));
        } else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementAddOrganizationType({ payload, token }) {
    try {
        const dataRes = yield settingAddOrganizationType(payload, token);
        if (dataRes.status === 'success') {
            yield put(getOrganizationType({ spa_id: payload.spa_id }, token));
        } else
            if
                (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }

            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else {
                yield PullNotificationManager(`${dataRes.msg}`);
            }

    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementUpdateOrganizationType({ payload, token }) {
    try {
        const dataRes = yield settingUpdateOrganizationType(payload, token);
        if (dataRes.status === 'success') {
            yield put(getOrganizationType({ spa_id: payload.spa_id }, token));
            // yield put(getCustomer({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ idHotel }, token));
            // yield put(getUser());
        } else
            if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }
            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementDeleteOrganizationType({ payload, token }) {
    const { items } = payload;
    try {
        const dataRes = yield settingDeleteOrganizationType(items, token);
        if (dataRes.status === 'success') yield put(getOrganizationType({ spa_id: payload.spa_id }, token));
        else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else if (dataRes.err.code === "ER_ROW_IS_REFERENCED_2") {
                yield PullNotificationManager("RoleType is used.");
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        console.log('error', error)
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementLoadOrganization({ payload, token }) {
    try {
        const dataRes = yield settingGetOrganization(payload, token);
        if (dataRes.status === 'success') {
            // const dataFilter = dataRes.data.filter(el => el.name_position === "Owner")
            // const allDataFilter = dataRes.data.filter(el => el.name_position !== "Owner")
            // const checkDataFilter = [...dataFilter || (null), ...allDataFilter || dataRes.data]
            const dataResNameTitle = yield addressGetNameTitle(token);
            if (dataResNameTitle.status === 'success') {
                const list = dataRes.data.map(item => {

                    let label = ""
                    if (item.organization_information_type === "Company") {
                        label = `${item.name_company || ""} ${item.name_branch}`

                    } else if (item.organization_information_type === "Personal") {

                        const nameTitleData = dataResNameTitle.data.find(el => el.value === item.id_NameTitle)
                        label = `${nameTitleData.label_shorten} ${item.personal_name}`

                    } else if (item.organization_information_type === "Government") {
                        label = item.organization_name || ""
                    }

                    return {
                        ...item,
                        label,
                        value: item.id_organization,
                    }
                });
                yield put(getOrganizationSuccess(dataRes.data, list));
            }
        } else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementAddOrganization({ payload, token }) {
    try {
        const dataRes = yield settingAddOrganization(payload, token);
        if (dataRes.status === 'success') {
            yield put(getOrganization({ spa_id: payload.spa_id }, token));
        } else
            if
                (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }

            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else {
                yield PullNotificationManager(`${dataRes.msg}`);
            }

    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementUpdateOrganization({ payload, token }) {
    try {
        const dataRes = yield settingUpdateOrganization(payload, token);
        if (dataRes.status === 'success') {
            yield put(getOrganization({ spa_id: payload.spa_id }, token));
            console.log("error");
            // yield put(getOrganizationCategory({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ idHotel }, token));
            // yield put(getUser());
        } else
            if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }
            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementDeleteOrganization({ payload, token }) {
    const { items } = payload;
    try {
        const dataRes = yield settingDeleteOrganization(items, token);
        if (dataRes.status === 'success') yield put(getOrganization({ spa_id: payload.spa_id }, token));
        else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else if (dataRes.err.code === "ER_ROW_IS_REFERENCED_2") {
                yield PullNotificationManager("RoleCategory is used.");
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        console.log('error', error)
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementLoadCustomer({ payload, token }) {
    try {
        const dataRes = yield settingGetCustomer(payload, token);
        if (dataRes.status === 'success') {
            // const dataFilter = dataRes.data.filter(el => el.name_position === "Owner")
            // const allDataFilter = dataRes.data.filter(el => el.name_position !== "Owner")
            // const checkDataFilter = [...dataFilter || (null), ...allDataFilter || dataRes.data]
            const list = dataRes.data.map(item => {
                // console.log(nameTitleData);
                const label = `${item.first_name} ${item.last_name}`
                // console.log(label);
                return {
                    ...item,
                    label,
                    value: item.id_customer,
                }
            });
            yield put(getCustomerSuccess(dataRes.data, list));
        } else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementAddCustomer({ payload, token }) {
    try {
        const dataRes = yield settingAddCustomer(payload, token);
        if (dataRes.status === 'success') {
            yield put(getCustomer({ spa_id: payload.spa_id }, token));
        } else
            if
                (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }

            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else {
                yield PullNotificationManager(`${dataRes.msg}`);
            }

    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementUpdateCustomer({ payload, token }) {
    try {
        const dataRes = yield settingUpdateCustomer(payload, token);
        if (dataRes.status === 'success') {
            yield put(getCustomer({ spa_id: payload.spa_id }, token));
            // yield put(getOrganizationType({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ idHotel }, token));
            // yield put(getUser());
        } else
            if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }
            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

// function* settingManagementChangeStatusCustomer({ payload, token }) {
//     try {
//         const dataRes = yield settingUpdateChangeStatusCustomer(payload, token);
//         if (dataRes.status === 'success') {
//             yield put(getCustomer({ spa_id: payload.spa_id }, token));

//         } else
//             if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
//                 yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
//                 // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
//             }
//             else if (dataRes.status === 'error' && dataRes.auth === false) {
//                 yield PullNotificationManager("TIME OUT! Please Login again.")
//                 // yield put(settingErrorMessage("TIME OUT! Please Login again."))
//             } else {
//                 yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//                 // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//             }
//     }
//     catch (error) {
//         yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//         // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//     }
// }

function* settingManagementDeleteCustomer({ payload, token }) {
    const { items } = payload;
    try {
        const dataRes = yield settingDeleteCustomer(items, token);
        if (dataRes.status === 'success') yield put(getCustomer({ spa_id: payload.spa_id }, token));
        else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else if (dataRes.err.code === "ER_ROW_IS_REFERENCED_2") {
                yield PullNotificationManager("RoleType is used.");
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        console.log('error', error)
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

// END Customer Management

// Customer Management
export function* watchLoadOrganizationType() {
    yield takeEvery(
        SETTING_LOAD_ORGANIZATION_TYPE,
        settingManagementLoadOrganizationType
    );
}
export function* watchAddOrganizationType() {
    yield takeEvery(
        SETTING_CREATE_ORGANIZATION_TYPE,
        settingManagementAddOrganizationType
    );
}
export function* watchUpdateOrganizationType() {
    yield takeEvery(
        SETTING_UPDATE_ORGANIZATION_TYPE,
        settingManagementUpdateOrganizationType
    );
}
export function* watchDeleteOrganizationType() {
    yield takeEvery(
        SETTING_DELETE_ORGANIZATION_TYPE,
        settingManagementDeleteOrganizationType
    );
}

export function* watchLoadOrganization() {
    yield takeEvery(
        SETTING_LOAD_ORGANIZATION,
        settingManagementLoadOrganization
    );
}
export function* watchAddOrganization() {
    yield takeEvery(
        SETTING_CREATE_ORGANIZATION,
        settingManagementAddOrganization
    );
}
export function* watchUpdateOrganization() {
    yield takeEvery(
        SETTING_UPDATE_ORGANIZATION,
        settingManagementUpdateOrganization
    );
}

export function* watchDeleteOrganization() {
    yield takeEvery(
        SETTING_DELETE_ORGANIZATION,
        settingManagementDeleteOrganization
    );
}

export function* watchLoadCustomer() {
    yield takeEvery(
        SETTING_LOAD_CUSTOMER,
        settingManagementLoadCustomer
    );
}
export function* watchAddCustomer() {
    yield takeEvery(
        SETTING_CREATE_CUSTOMER,
        settingManagementAddCustomer
    );
}
export function* watchUpdateCustomer() {
    yield takeEvery(
        SETTING_UPDATE_CUSTOMER,
        settingManagementUpdateCustomer
    );
}
// export function* watchChangeStatusCustomer() {
//     yield takeEvery(
//         SETTING_UPDATE_CUSTOMER_STATUS,
//         settingManagementChangeStatusCustomer
//     );
// }
export function* watchDeleteCustomer() {
    yield takeEvery(
        SETTING_DELETE_CUSTOMER,
        settingManagementDeleteCustomer
    );
}

// END Customer Management

export default function* rootSaga() {
    yield all([
        //  Customer Management 
        fork(watchLoadOrganizationType),
        fork(watchAddOrganizationType),
        fork(watchUpdateOrganizationType),
        fork(watchDeleteOrganizationType),

        fork(watchLoadOrganization),
        fork(watchAddOrganization),
        fork(watchUpdateOrganization),
        fork(watchDeleteOrganization),

        fork(watchLoadCustomer),
        fork(watchAddCustomer),
        fork(watchUpdateCustomer),
        // fork(watchChangeStatusCustomer),
        fork(watchDeleteCustomer),

    ])
}